import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextAlignLeftFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 6H4a2 2 0 0 1 0-4h24a2 2 0 0 1 0 4m-7 8H4a2 2 0 0 1 0-4h17a2 2 0 0 1 0 4m7 8H4a2 2 0 0 1 0-4h24a2 2 0 0 1 0 4m-13 8H4a2 2 0 0 1 0-4h11a2 2 0 0 1 0 4" />
  </svg>
);
const ForwardRef = forwardRef(IconTextAlignLeftFilledSVG);
ForwardRef.displayName = "IconTextAlignLeftFilled";
export { ForwardRef as IconTextAlignLeftFilled };
